import { Link } from 'react-router-dom';
import { Producto, estaAgotado } from '../../types/catalogo';
import { Card } from '../shared/Card';

function precioDesde(producto: Producto): number {
  return Math.min(...producto.paquetes.map((p) => p.precio), Infinity);
}

export function ProductCard({ producto }: { producto: Producto }) {
  const agotado = estaAgotado(producto);
  const precio = precioDesde(producto);

  return (
    <Link to={`/catalogo/${producto.id}`} data-testid={`product-card-${producto.id}`}>
      <Card className="flex flex-col hover:shadow-md transition-shadow">
        <div
          className="h-40 bg-cover bg-center relative"
          style={{
            backgroundImage: producto.imagenes[0] ? `url(${producto.imagenes[0]})` : undefined,
            backgroundColor: producto.imagenes[0] ? undefined : 'oklch(85% 0.05 55)',
          }}
        >
          {agotado && (
            <div className="absolute inset-0 bg-ink/60 flex items-center justify-center">
              <span className="bg-ink/80 text-white text-[11px] font-bold px-3 py-1 rounded">
                AGOTADO
              </span>
            </div>
          )}
        </div>
        <div className={`p-4 flex flex-col gap-1 ${agotado ? 'opacity-55' : ''}`}>
          <div className="text-sm font-semibold text-ink">{producto.nombre}</div>
          {Number.isFinite(precio) && (
            <div className="text-sm text-ink-muted">Desde S/ {precio.toFixed(2)}</div>
          )}
        </div>
      </Card>
    </Link>
  );
}
